import React, { useState, useEffect } from 'react';

type DebugWindow = Window & { DEBUG_LOGS?: boolean; DEBUG_RESPONSES?: boolean };
import { LABS_KEY, defaultSettings } from '../constants';
import type { LabsSettings } from '../types';

function loadSettings(): LabsSettings {
  try {
    const raw = localStorage.getItem(LABS_KEY);
    if (raw) return { ...defaultSettings, ...JSON.parse(raw) };
  } catch {
    return { ...defaultSettings };
  }
  return { ...defaultSettings };
}

function saveSettings(settings: LabsSettings) {
  localStorage.setItem(LABS_KEY, JSON.stringify(settings));
}

export function useLabsSettings() {
  const [settings, setSettings] = useState<LabsSettings>(loadSettings);

  const handleToggle = (key: keyof LabsSettings) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    console.debug('[LabsPage] Toggle changed:', key, newValue);
    setSettings((s) => ({ ...s, [key]: newValue }));
  };

  const handleText = (key: keyof LabsSettings) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    console.debug('[LabsPage] Text changed:', key, newValue);
    setSettings((s) => ({ ...s, [key]: newValue }));
  };

  useEffect(() => {
    saveSettings(settings);
    if (typeof window !== 'undefined') {
      (window as DebugWindow).DEBUG_LOGS = !!settings.debug;
      (window as DebugWindow).DEBUG_RESPONSES = !!settings.debugNetwork;
    }
  }, [settings]);

  useEffect(() => {
    saveSettings(settings);
    if (typeof window !== 'undefined') {
      (window as DebugWindow).DEBUG_LOGS = !!settings.debug;
      (window as DebugWindow).DEBUG_RESPONSES = !!settings.debugNetwork;
    }
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'labs-sync', settings });
    }
  }, [settings]);

  return { settings, setSettings, handleToggle, handleText };
}
